import PropTypes from "prop-types";
import React from 'react'
import Layout from '../components/layout/Layout'
import { SEO } from 'gatsby-theme-seo'

import DecryptTitle from '../components/decryptTitle'
import Image from '../components/pageImages'

import { BLOCKS, MARKS } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"


export default function Sobre({ data }) {
  const { contentfulPaginas } = data
  const { pageImage, body } = contentfulPaginas
  const { description } = pageImage

  return (
    <Layout id="sobre" additionalClassName="md:h-screen" contentAlignment="center">
      <SEO title="Sobre" />
        <div className="container mx-auto text-center mt-12">
          <DecryptTitle data={data} spaceAfter={3} className="text-3xl lg:text-5xl font-semibold leading-loose" />
          <div className="flex flex-col sm:flex-row sm:-mx-3">

            <div className="flex flex-1 px-3 items-center justify-center">
              <Image data={data} alt={ !description ? null : description } className="w-1/2 self-center" />              
            </div>
            <div className="flex-1 px-3 text-justify">
              {documentToReactComponents(body.json, {
                renderMark: {
                  [MARKS.BOLD]: text => <span className="font-bold">{text}</span>,
                  [MARKS.ITALIC]: text => <span className="italic]">{text}</span>,
                  [MARKS.UNDERLINE]: text => <span className="underline">{text}</span>,
                  [MARKS.CODE]: text => <span className="font-mono tracking-wider">{text}</span>,
                },
                renderNode: {
                  [BLOCKS.HEADING_1]: (_node, children) => (
                    <h1>{children}</h1>
                  ),
                  [BLOCKS.HEADING_2]: (_node, children) => (
                    <h2>{children}</h2>
                  ),
                  [BLOCKS.HEADING31]: (_node, children) => (
                    <h3>{children}</h3>
                  ),
                  [BLOCKS.HEADING_4]: (_node, children) => (
                    <h4>{children}</h4>
                  ),
                  [BLOCKS.HEADING_5]: (_node, children) => (
                    <h5>{children}</h5>
                  ),
                  [BLOCKS.HEADING_6]: (_node, children) => (
                    <h6>{children}</h6>
                  ),
                  [BLOCKS.PARAGRAPH]: (_node, children) => <p className="text-lg mt-6 font-light">{children}</p>,
                  [BLOCKS.QUOTE]: (_node, children) => <blockquote>{children}</blockquote>,
                },
              })}
            </div>
          </div>
        </div>
    </Layout>
  )
}

Sobre.propTypes = {
  data: PropTypes.any
}

export const pageQuery = graphql`
  query {
    contentfulPaginas(
      slug: {
        eq: "sobre"
      }
    ) {
      titulo
      decrypt
      tituloDecrypt {
        textoNormal
        textoDecrypt
        posicionamento
      }
      body {
        json
      }
      pageImage {
        fluid(toFormat: PNG) {
          ...GatsbyContentfulFluid
        }
        title
        description
        file {
          contentType
          url
        }
      }
    }
  }
`